import type { BenchLiveStepTreeState, BenchStepTreeEntry } from "@/lib/sdtestapp/sdTestAppBenchClient";
import { cn } from "@/lib/utils";

export function BenchBatchStepTree({
  entries,
  liveState,
}: {
  entries: BenchStepTreeEntry[];
  liveState?: BenchLiveStepTreeState | null;
}): JSX.Element {
  const displayEntries = liveState?.live && liveState.entries.length > 0 ? liveState.entries : entries;
  if (displayEntries.length === 0) {
    return <p className="text-sm text-muted-foreground">Select a sequence to preview its steps.</p>;
  }

  const completed = new Set(liveState?.completedIndices ?? []);
  const skipped = new Set(liveState?.skipIndices ?? []);
  const currentIndex = liveState?.currentIndex ?? null;

  return (
    <ol className="max-h-64 space-y-1 overflow-y-auto rounded border p-2 text-sm">
      {displayEntries.map((entry, index) => (
        <li
          key={`${entry.type}-${entry.label}-${index}`}
          className={cn(
            "flex gap-2 border-b py-1 last:border-b-0",
            currentIndex === index && "bg-amber-50",
            completed.has(index) && "text-emerald-800",
            skipped.has(index) && "text-muted-foreground line-through",
          )}
        >
          <span className="w-6 shrink-0 text-muted-foreground">{index + 1}.</span>
          <span className="min-w-0 flex-1">
            <span className="font-medium">{entry.label}</span>
            {entry.nestedSequenceOrigin ? (
              <span className="ml-1 text-xs text-muted-foreground">({entry.nestedSequenceOrigin})</span>
            ) : null}
          </span>
        </li>
      ))}
    </ol>
  );
}
